module.exports = __webpack_public_path__ + "static/img/laborOffcr.c088926.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/laborOffcr.png
// module id = pPBE
// module chunks = 0